




























import { Component } from 'vue-property-decorator';

import bLink from 'bootstrap-vue/es/components/link/link';

import fontSizePropValidator from '@/lib/fontSizePropValidator';

import ProductFeature from './ProductFeature';

@Component({
  components: {
    bLink,
  },
  props: {
    size: {
      type: String,
      default: 'large',
      validator: fontSizePropValidator,
    },
  },
})
export default class TitleFeature extends ProductFeature { }

